import { Form, FormItem, FormList } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SForm = styled(Form)``;

export const SFormItem = styled(FormItem)``;

export const SFormList = styled(FormList)``;
